'use strict';

module.exports = function ($) {

/////////////////////////////////////////////
//           jQuery Easing 1.3            //
///////////////////////////////////////////

  // t: current time, b: begInnIng value, c: change In value, d: duration
  $.easing.jswing = $.easing.swing;

  $.extend($.easing, {
    def: 'easeOutQuad',
    swing: function (x, t, b, c, d) {
      return $.easing[$.easing.def](x, t, b, c, d);
    },
    easeOutQuad: function (x, t, b, c, d) {
      return -c * (t /= d) * (t - 2) + b;
    },

    // In use material family
    easeInOutCubic: function (x, t, b, c, d) {
      if ((t /= d / 2) < 1) { return c / 2 * t * t * t + b; }
      return c / 2 * ((t -= 2) * t * t + 2) + b;
    },
    // In use shared.jquery
    easeOutQuart: function (x, t, b, c, d) {
      return -c * ((t = t / d - 1) * t * t * t - 1) + b;
    },
    // In use fancybox
    easeInOutSine: function (x, t, b, c, d) {
      return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
    },
    // In use
    easeOutExpo: function (x, t, b, c, d) {
      return (t === d) ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
    }
  });
};
